export default __webpack_public_path__ + "static/screenshot_3d-d854c39312ecf4a556f22847e5eacd23.png";